import React from 'react';

/**
 * Renders **double-asterisk** spans in content.js strings as bold text.
 * Everything else is passed through untouched.
 */
export default function richText(text) {
  if (!text) return null;

  return text.split(/(\*\*[^*]+\*\*)/g).map((part, i) => {
    if (part.startsWith('**') && part.endsWith('**') && part.length > 4) {
      return <strong key={i}>{part.slice(2, -2)}</strong>;
    }
    return <React.Fragment key={i}>{part}</React.Fragment>;
  });
}
